import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import loaderSrc from '../assets/loader.svg';

import { LoadingProps } from './types';

const useStyles = makeStyles(() => ({
  loading: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loading__glow: {
    position: 'absolute',
    inlineSize: '300px',
    blockSize: '300px',
    borderRadius: '50%',
    filter: 'blur(60px)',
    background: 'radial-gradient(circle, rgba(248, 214, 139, 0.55) 0%, rgba(248, 214, 139, 0) 70%)',
    pointerEvents: 'none'
  },
  loading__image: {
    position: 'relative',
    display: 'block',
    inlineSize: '180px',
    maxInlineSize: '60vw',
    blockSize: 'auto'
  }
}));

export const Loading: FC<LoadingProps> = ({ label }) => {
  const classes = useStyles();

  return (
    <div className={classes.loading} role="status" aria-label={label}>
      <div className={classes.loading__glow} />
      <img src={loaderSrc} alt="" className={classes.loading__image} />
    </div>
  );
};

export default Loading;
